<template>
    <div class="datamain">
        <Header />
        <Breed />
        <div class="databox">
            <div class="panel-card">
                <div class="section-title">草莓产地货源价格</div>
                <div class="section-content">
                    <div class="section-content-header">
                        <div class="tip">
                            <div class="price-card">
                                <div class="price-item">
                                    <span class="label">今日均价</span>
                                    <span class="value" style="color: #F92C15;"><span class="icon">¥</span><span
                                            class="value-num">10.28</span><span class="unit">元/斤</span></span>
                                </div>
                                <div class="price-item">
                                    <span class="label" style="color: #B6BCC7;">相比于昨日</span>
                                    <span class="value"><span style="color: #B6BCC7;">平稳</span> 0.0<span
                                            class="trend-icon">▲</span></span>
                                </div>
                            </div>
                        </div>
                        <div class="select">
                            <div class="time-filter">
                                <button class="filter-btn active">近7天</button>
                                <button class="filter-btn">近30天</button>
                                <button class="filter-btn">近60天</button>
                            </div>
                        </div>
                    </div>
                    <div class="chart-container">
                        <div class="chart-header">
                            <button @click="forceRenderChart" class="test-btn">强制渲染图表</button>
                        </div>
                        <div ref="priceChart" class="price-chart"></div>
                    </div>
                </div>
            </div>
            <div class="panel-card">
                <div class="section-title">草莓产地行情</div>
            </div>
            <div class="panel-card">
                <div class="section-title">红颜草莓 销地批发市场价格</div>
                <div class="section-content">
                    <div class="section-content-header">
                        <div class="tip">
                            <div class="price-card">
                                <div class="price-item">
                                    <span class="label">今日均价</span>
                                    <span class="value" style="color: #F92C15;"><span class="icon">¥</span><span
                                            class="value-num">10.28</span><span class="unit">元/斤</span></span>
                                </div>
                                <div class="price-item">
                                    <span class="label" style="color: #B6BCC7;">相比于昨日</span>
                                    <span class="value"><span style="color: #B6BCC7;">平稳</span> 0.0<span
                                            class="trend-icon">▲</span></span>
                                </div>
                            </div>
                        </div>
                        <div class="select">
                            <div class="time-filter">
                                <button class="filter-btn active">近7天</button>
                                <button class="filter-btn">近30天</button>
                                <button class="filter-btn">近60天</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-card">
                <div class="section-title">红颜草莓产地一手货源</div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './Header.vue'
import Breed from '@/components/breed.vue'
import * as echarts from 'echarts'

export default {
    name: 'breakingNews',
    components: {
        Header,
        Breed
    },
    data() {
        return {
            priceChart: null,
            chartData: {
                dates: ['2025-04-06', '2025-04-07', '2025-04-08', '2025-04-09', '2025-04-10', '2025-04-11', '2025-04-12'],
                prices: [10.05, 9.95, 10.15, 10.25, 10.12, 9.98, 10.05]
            }
        }
    },
    mounted() {
        // 延迟初始化图表，确保DOM完全渲染
        setTimeout(() => {
            this.initPriceChart()
        }, 100)
    },
    methods: {
        initPriceChart() {
            this.$nextTick(() => {
                try {
                    const chartDom = this.$refs.priceChart
                    if (!chartDom) {
                        console.error('图表DOM元素未找到')
                        return
                    }
                    
                    console.log('图表DOM元素:', chartDom)
                    console.log('图表容器尺寸:', chartDom.offsetWidth, 'x', chartDom.offsetHeight)
                    
                    // 确保容器有尺寸
                    if (chartDom.offsetWidth === 0 || chartDom.offsetHeight === 0) {
                        console.log('容器尺寸为0，等待下一帧')
                        setTimeout(() => this.initPriceChart(), 50)
                        return
                    }
                    
                    this.priceChart = echarts.init(chartDom)
                    
                    // 使用更简单的配置
                    const option = {
                        title: {
                            text: '草莓产地货源价格趋势',
                            textStyle: {
                                color: '#FFFFFF',
                                fontSize: 16
                            },
                            left: 'center',
                            top: 10
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        xAxis: {
                            type: 'category',
                            data: this.chartData.dates,
                            axisLabel: {
                                color: '#FFFFFF'
                            }
                        },
                        yAxis: {
                            type: 'value',
                            axisLabel: {
                                color: '#FFFFFF'
                            }
                        },
                        series: [{
                            name: '价格',
                            type: 'line',
                            data: this.chartData.prices,
                            color: '#1286FF'
                        }]
                    }
                    
                    this.priceChart.setOption(option)
                    console.log('图表初始化成功')
                    
                } catch (error) {
                    console.error('图表初始化失败:', error)
                }
            })
        },
        forceRenderChart() {
            this.initPriceChart();
        }
    },
    beforeDestroy() {
        if (this.priceChart) {
            this.priceChart.dispose()
        }
    }
}
</script>

<style lang="less" scoped>
@font-face {
    font-family: 'title';
    src: url('../assets/font/title.ttf');
}

.datamain {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #030a2e;
}

.databox {
    margin: 10px;
    background: rgba(0, 11, 47, 0.5);
    box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
    border-radius: 0px 0px 0px 0px;
    height: calc(100vh - 160px);

    /* 使用 CSS Grid 将容器均匀分成4份 */
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* 2列等宽 */
    grid-template-rows: 1fr 1fr;
    /* 2行等高 */
    gap: 10px;
    /* 网格间距 */
    padding: 10px;
    /* 内边距 */
}

.panel-card {
    height: 100%;
}

.section-title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    text-indent: 10px;
    text-shadow: 0px 0px 8px #1286FF;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.section-content {
    width: 100%;
    padding: 14px 24px;
    height: calc(100% - 50px);
    background-color: #030a2e;

    .section-content-header {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .tip {
            width: 300px;
            height: 90px;
            background: rgba(0, 32, 67, 0.6);
            box-shadow: inset 0px 0px 14px 0px #0691ED;
            border-radius: 0px 0px 0px 0px;

            .price-card {
                width: 100%;
                height: 100%;
                padding: 15px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                position: relative;

                .price-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .label {
                        color: #FFFFFF;
                        font-size: 14px;
                        font-weight: 400;
                    }

                    .value {
                        font-size: 14px;
                        font-weight: 500;
                        color: #FFFFFF;

                        .value-num {
                            font-size: 24px;
                        }

                    }

                    .trend-icon {
                        display: inline-block;
                        margin-left: 4px;
                        margin-bottom: 4px;
                        font-size: 10px;
                        color: #fff;
                        vertical-align: middle;
                    }
                }
            }
        }

        .select {
            .time-filter {
                display: flex;

                .filter-btn {
                    padding: 4px 12px;
                    background: rgba(0, 32, 67, 0.8);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    color: #FFFFFF;
                    font-size: 14px;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &:hover {
                        background: rgba(6, 145, 237, 0.3);
                        border-color: #0691ED;
                    }

                    &.active {
                        background: linear-gradient(270deg, #00A1FF 0%, #006AFF 100%);
                        border-color: #0691ED;
                        box-shadow: 0 0 10px rgba(6, 145, 237, 0.5);
                    }
                }
            }
        }
    }
}

.chart-container {
    width: 100%;
    height: 350px;
    margin-top: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 32, 67, 0.2);
    
    .chart-header {
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        
        .test-btn {
            padding: 6px 12px;
            background: rgba(6, 145, 237, 0.8);
            border: 1px solid #0691ED;
            color: #FFFFFF;
            font-size: 12px;
            cursor: pointer;
            border-radius: 4px;
            transition: all 0.3s ease;
            
            &:hover {
                background: rgba(6, 145, 237, 1);
                box-shadow: 0 0 10px rgba(6, 145, 237, 0.5);
            }
        }
    }
    
    .price-chart {
        width: 100%;
        height: calc(100% - 40px);
        min-height: 300px;
    }
}

@keyframes glow {
    0% {
        box-shadow: 0 0 20px rgba(6, 145, 237, 0.3);
    }

    100% {
        box-shadow: 0 0 30px rgba(6, 145, 237, 0.6);
    }
}
</style>